/// <amd-module name="SuiteCommerce.ItemRecSys.WidgetCct.ItemView"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.ItemRecSys.WidgetCct.ItemView", ["require", "exports", "Backbone", "ns_recsys_widget_cct_item.tpl", "Utils", "SC.Configuration", "GlobalViews.StarRating.View", "Cart.QuickAddToCart.View", "Cart.AddToCart.Button.View", "ProductViews.Price.View", "Product.Model"], function (require, exports, Backbone_1, item_tpl, Utils, Configuration, GlobalViewsStarRatingView, CartQuickAddToCartView, CartQuickAddToCartButton, ProductViewsPriceView, ProductModel) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ItemView = void 0;
    var RecSysCartQuickAddToCartButton = /** @class */ (function (_super) {
        __extends(RecSysCartQuickAddToCartButton, _super);
        function RecSysCartQuickAddToCartButton() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        RecSysCartQuickAddToCartButton.prototype.addToCart = function (e) {
            this.$el.trigger('recSysWidgetQuickAddToCart', { 'target': 'quickAddToCart' });
            return _super.prototype.addToCart.call(this, e);
        };
        return RecSysCartQuickAddToCartButton;
    }(CartQuickAddToCartButton));
    var RecSysCartQuickAddToCartView = /** @class */ (function (_super) {
        __extends(RecSysCartQuickAddToCartView, _super);
        function RecSysCartQuickAddToCartView() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(RecSysCartQuickAddToCartView.prototype, "childViews", {
            get: function () {
                return {
                    AddToCart: function () {
                        return new RecSysCartQuickAddToCartButton({ model: this.model, application: this.options.application });
                    },
                    'ProductViewsPrice.Price': function () {
                        return new ProductViewsPriceView({ model: this.model, origin: 'RecSysWidget' });
                    }
                };
            },
            enumerable: false,
            configurable: true
        });
        return RecSysCartQuickAddToCartView;
    }(CartQuickAddToCartView));
    var ItemView = /** @class */ (function (_super) {
        __extends(ItemView, _super);
        function ItemView() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.template = item_tpl;
            _this.events = {
                'click.widget a': 'handleItemClicked',
                'recSysWidgetQuickAddToCart': 'handleItemClicked'
            };
            return _this;
        }
        ItemView.prototype.handleItemClicked = function () {
            this.options.clickEventHandler(this.model.get('_id'));
        };
        ItemView.prototype.shouldShowRating = function () {
            return SC.ENVIRONMENT.REVIEWS_CONFIG && SC.ENVIRONMENT.REVIEWS_CONFIG.enabled;
        };
        Object.defineProperty(ItemView.prototype, "childViews", {
            get: function () {
                return {
                    'Item.Price': function () {
                        return new ProductViewsPriceView({
                            model: this.model,
                            origin: 'RecSysWidget'
                        });
                    },
                    'GlobalViews.StarRating': function () {
                        return new GlobalViewsStarRatingView({
                            model: this.model,
                            showRatingCount: false,
                            queryOptions: Utils.parseUrlOptions(location.href)
                        });
                    },
                    'Cart.QuickAddToCart': function () {
                        var product = new ProductModel({
                            item: this.model,
                            quantity: this.model.get('_minimumQuantity')
                        });
                        return new RecSysCartQuickAddToCartView({
                            model: product,
                            application: this.options.container,
                            origin: 'RecSysWidget'
                        });
                    },
                };
            },
            enumerable: false,
            configurable: true
        });
        ItemView.prototype.getContext = function () {
            return {
                // @property {String} itemId
                itemId: this.model.get('_id'),
                // @property {String} name
                name: this.model.get('_name'),
                // @property {String} url
                url: this.model.get('_url'),
                // @property {String} sku
                sku: this.model.getSku(),
                // @property {Boolean} showQuickView
                showQuickView: SC.ENVIRONMENT.jsEnvironment === 'browser' && !SC.ENVIRONMENT.isTouchEnabled && Configuration.get("intelligentrecommendations.showQuickViewButton"),
                // @property {ImageContainer} thumbnail
                thumbnail: this.model.getThumbnail(),
                // @property {Boolean} showRating
                showRating: this.shouldShowRating(),
                // @property {Number} rating
                rating: this.model.get('_rating'),
            };
        };
        return ItemView;
    }(Backbone_1.View));
    exports.ItemView = ItemView;
});
